import React from 'react'
import { preApprovalCategory } from 'ppbl/utils/constants'
import { CaptionText, PAYPAL_THEME } from '@paypalcorp/pp-react'
import getDisclaimerContent from './__utils__'
import './index.css'


type DisclaimerProps = {
  approvalCategory: preApprovalCategory,
}

const captionStyle = {
  color: PAYPAL_THEME.sysColorBackgroundMediumContrast,
  textAlign: 'left' as const,
}

const Disclaimer: React.FC<DisclaimerProps> = ({ approvalCategory }) => {
  const disclaimerContent = getDisclaimerContent(approvalCategory) ?? ''

  return (
    <div className="disclaimerWrapper">
      <CaptionText style={captionStyle}>
        {disclaimerContent}
      </CaptionText>
    </div>
  )
}

export default Disclaimer
